import { GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { IFlowState, IFlowSchedule, IFlowSchedules, FlowStep } from "./types";

type FlowGetterTree = GetterTree<IFlowState, RootState>;

const WAIT_ROUTE = "/assessment-wait";
const DONE_ROUTE = "/assessment-done";
const OFFLINE_ROUTE = "/assessment-done";

const getAssessmentRoute = (goto?: string): string => {
  if (goto) {
    return `/assessment/${goto}`;
  }

  return "";
};

const getPreviousAssessemteRoute = (
  schedules: IFlowSchedules | null
): string => {
  const schedule = Object.entries(schedules || {})
    .filter(s => s[1].is_completed)
    .map(s => s[1])
    .pop();

  if (schedule) {
    const subject = schedule.subject.toLowerCase();
    const test_num = schedule.test_num;
    return `/assessment/${subject}/${test_num}`;
  }

  return "";
};

export const getters: FlowGetterTree = {
  goto(state: IFlowState): string {
    const { step, schedules, goto } = state;

    if (step === null || step === FlowStep.Wait) {
      return WAIT_ROUTE;
    } else if (step === FlowStep.Section) {
      return getAssessmentRoute(goto);
    } else if (step === FlowStep.Review) {
      return getPreviousAssessemteRoute(schedules);
    } else if (step === FlowStep.Done) {
      return DONE_ROUTE;
    }

    return "";
  },

  wait(state: IFlowState): number {
    const { wait } = state;
    return wait ? +wait : 0;
  },

  etl(state: IFlowState): boolean {
    return !!state.etl;
  },

  canStart(state: IFlowState): boolean {
    const { wait, etl } = state;

    if (etl && wait != undefined && wait <= 0) {
      return true;
    } else {
      return false;
    }
  },

  getPreviousSubject(state: IFlowState): string {
    const { schedules } = state;

    const subject = Object.entries(schedules || {})
      .filter(s => s[1].is_completed)
      .map(s => s[1].subject)
      .pop();
    return subject || "";
  },

  schedule(state: IFlowState): IFlowSchedules | {} {
    const { subject, schedules } = state;

    if (!!schedules && !!subject) {
      return schedules[subject.toLowerCase()];
    }

    return {};
  },

  schedules(state: IFlowState): IFlowSchedule | {} {
    const { schedules } = state;
    return schedules || {};
  },

  isOngoingAssessment(state: IFlowState): boolean {
    const { schedules } = state;
    return Object.values(schedules || {}).some(s => s.is_completed);
  },
};
